import { PermissionObjectIds } from "./PermissionObjects";

export enum DefaultPageKeys {
    DUMMY_0 = "",
    QUOTATION = "QT",
    PURCHASE_ORDER = "PO",
    INVOICE = "IV",
    DUMMY_4 = "",
    DUMMY_5 = "",
    DUMMY_6 = "",
    DUMMY_7 = "",
    DUMMY_8 = "",
    DUMMY_9 = "",
    DUMMY_10 = "",
    DUMMY_11 = "",
    DUMMY_12 = "",
    DUMMY_13 = "",
    DUMMY_14 = "",
    DUMMY_15 = "",
    DUMMY_16 = "",
    DUMMY_17 = "",
    DUMMY_18 = "",
    DUMMY_19 = "",
    DUMMY_20 = "",
    DUMMY_21 = "",
    DUMMY_22 = "",
    DUMMY_23 = "",
    ACCOUNT_SYSTEM = "AC"
};

export function getDefaultPageAbbreviationById(permissionId: PermissionObjectIds)
{
    return Object.values(DefaultPageKeys)[permissionId];
}